goog.provide("shadow.js.shim.module$$mui$material$Card$default");
shadow.js.shim.module$$mui$material$Card$default = shadow.js.shim.module$$mui$material$Card.default;
